import { commonShortFieldLabels } from "./common-short-fields";

export const examAdminAiTasks = {
  pageTitle: "AI ワークスペース",
  pageSubtitle:
    "タスクテンプレートから AI タスクを作成し、AI による出題、組版、採点の実フローを実行します。",
  drawers: {
    createTitle: "AI タスクを作成",
    updateTitle: "AI タスクを更新",
    updateTitleWithId: "AI タスク #{id} を更新",
  },
  fields: {
    taskType: "タスク種別",
    sourceModule: "ソースモジュール",
    sourceRefId: "ソース対象 ID",
    modelName: "モデル名",
    promptVersion: "Prompt バージョン",
    inputJson: "input_json プレビュー",
    taskStatus: "実行状態",
    reviewStatus: "レビュー状態",
    resultJson: "result_json",
  },
  actions: {
    create: "AI タスクを作成",
    runTask: "タスクを実行",
    applyResult: "結果を適用",
    updateResult: "結果を更新",
    saveUpdate: "更新を保存",
  },
  messages: {
    createSuccess: "AI タスクを作成しました",
    updateSuccess: "AI タスクを更新しました",
    runSuccess: "AI タスクが完了しました。モード: {mode}",
    applySuccess: "AI 結果を {targetType} ドラフト #{targetId} として適用しました",
    appliedTarget: "{type} #{id} として適用済み",
  },
  summary: {
    total: "タスク総数：{count}",
    completed: "完了：{count}",
    pending: "待機中：{count}",
    failed: "失敗：{count}",
  },
  table: {
    taskType: "タスク種別",
    sourceModule: "ソースモジュール",
    taskStatus: "実行状態",
    reviewStatus: "レビュー状態",
    model: "モデル",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  options: {
    taskTypes: {
      ingest: "AI 取り込み",
      generateQuestion: "AI 出題",
      generatePaper: "AI 組版",
      scoreSubjective: "AI 採点",
      extractKnowledge: "知識点抽出",
    },
    taskStatusPending: "待機中",
    taskStatusRunning: "実行中",
    taskStatusCompleted: "完了",
    taskStatusFailed: "失敗",
    reviewStatusPending: "レビュー待ち",
    reviewStatusApproved: "承認済み",
    reviewStatusRejected: "却下済み",
  },
  editor: {
    required: "必須項目です",
    candidateQuestionTitle: "候補問題 {index}",
    previewHint:
      "AI ワークスペースではテンプレート化されたフォームで入力を管理し、input_json を自動生成します。",
    sections: {
      ingestInput: "取り込み入力",
      generateQuestionInput: "出題入力",
      generatePaperInput: "組版入力",
      scoreInput: "採点入力",
      extractKnowledgeInput: "知識点抽出入力",
    },
    fields: {
      topic: "テーマ",
      sourceText: "元資料",
      constraints: "制約条件",
      availableQuestions: "候補問題",
      questionVersionId: "問題バージョン ID（数値）",
      questionTitle: "問題タイトル",
      knowledgePoints: "知識点",
      candidateAnswer: "受験者解答",
      fullScore: "満点",
      referencePoints: "採点観点",
    },
    actions: {
      addConstraint: "制約を追加",
      addCandidateQuestion: "候補問題を追加",
      addKnowledgePoint: "知識点を追加",
      addReferencePoint: "採点観点を追加",
    },
    placeholders: {
      ingestSourceText: "元資料を入力すると、AI が問題ドラフトに整理します",
      constraint: "例：SQL インジェクションに限定すること",
      knowledgePoint: "例：SQL インジェクション",
      referencePoint: "例：注入原理に言及している",
      sourceModule: "例：question_bank / paper / review",
      modelName: "未入力の場合は Intelligence Center のモデル接続既定設定を使用します",
      promptVersion: "v1",
    },
    templates: {
      topic: {
        sqlInjection: "SQL インジェクション",
      },
      ingest: {
        title: "SQL インジェクション事例読解問題",
        sourceText:
          "あるシステムではログイン時にユーザー名とパスワードを SQL クエリへ直接連結しており、攻撃者が細工した入力で認証を回避できます。この資料をもとに短答式問題を 1 問作成してください。",
      },
      generateQuestion: {
        constraintSecurityFocused:
          "Web セキュリティにおける SQL インジェクションを主題とし、一般的な SQL 問題にしないこと",
        constraintDifferentiate: "原理理解と防御方針の理解を区別できる内容にすること",
      },
      generatePaper: {
        question1Title: "SQL インジェクションの基礎識別",
        question1KnowledgePoint: "注入の識別",
        question2Title: "SQL インジェクション原理の分析",
        question2KnowledgePoint: "注入の原理",
      },
      scoreSubjective: {
        questionTitle: "SQL インジェクションの原理と 2 つの防御方法を説明してください",
        questionStem: "SQL インジェクションの原理と 2 つの防御方法を説明してください",
        point1: "ユーザー入力が SQL 文に直接連結されている",
        point2: "攻撃者がクエリの論理を変更できる",
        point3: "パラメータ化クエリ",
        point4: "入力検証または最小権限",
        answer:
          "SQL インジェクションとは、悪意ある入力を SQL に直接連結することで本来のクエリの論理を変えてしまう攻撃です。防御にはパラメータ化クエリを使い、入力検証も組み合わせます。",
      },
      extractKnowledge: {
        stem: "SQL インジェクション、ブール型ブラインド SQL インジェクション、時間ベースのブラインド SQL インジェクションの違いを分析し、一般的な防御戦略を説明してください。",
      },
    },
  },
} as const;
